export default (node) => {

    const twitterShareBtn = node.querySelector(".features__item__twitter");
    const facebookShareBtn = node.querySelector(".features__item__facebook");
    const linkedInShareBtn = node.querySelector(".features__item__linkedin");

    const copyLinkBtn = node.querySelector(".features__item__copy button");
    const linkCopied = node.querySelector(".features__item__link-copied");
    const printBtn = node.querySelector(".features__item__print");

    const mainContent = document.querySelector(".main-content");
    const progressBar = node.querySelector(".features__progress");
    
    const DEFAULT_POPUP_SIZES = {
		default: {
			width: 500,
			height: 320
		},
		fb: {
			width: 555,
			height: 320
		},
		linkedIn: {
			width: 500,
			height: 310
		},
		twitter: {
			width: 500,
			height: 310
		},
	};

    const openPopup = (
		url,
		width = DEFAULT_POPUP_SIZES.default.width,
		height = DEFAULT_POPUP_SIZES.default.height
	) => {
		const left = window.screenLeft + (window.outerWidth - width) * .5;
		const top = window.screenTop + (window.outerHeight - height) * .5;
		const options = [
			'width=' + width,
			'height=' + height,
			'top=' + top,
			'left=' + left,
			'scrollbars=1,location=0,menubar=0,resizable=0,status=0,toolbar=0'
		].join(',');
		window.open(url, 'popupShare', options);
	}

    const onTwitterClick = (event) => {
        event.preventDefault();
        
        const url = event.currentTarget.href;
        openPopup(url, DEFAULT_POPUP_SIZES.twitter.width, DEFAULT_POPUP_SIZES.twitter.height);
    };

    const onFacebookClick = (event) => {
        event.preventDefault();
        
        const url = event.currentTarget.href;
        openPopup(url, DEFAULT_POPUP_SIZES.fb.width, DEFAULT_POPUP_SIZES.fb.height);
    };

    const onLinkedInClick = (event) => {
        event.preventDefault();

        const url = event.currentTarget.href;
        openPopup(url, DEFAULT_POPUP_SIZES.linkedIn.width, DEFAULT_POPUP_SIZES.linkedIn.height);
    };

    const onCopyLinkClick = (event) => {
        navigator.clipboard.writeText(window.location.href).then(() => {
            linkCopied.classList.add("features__item__link-copied--show");
            linkCopied.focus();
            copyLinkBtn.setAttribute("aria-describedby","features-copied");
            
            setTimeout(() => {
                linkCopied.classList.remove("features__item__link-copied--show");
            }, 2000);
        });
    };

    const onPrintClick = (event) => {
        window.print();
    };

    const onScroll = (event) => {
        const currentScrollY = window.scrollY;

        const mainContentRect = mainContent.getBoundingClientRect();
        /*const mainContentTop = window.scrollY + mainContentRect.top;
        const mainContentBottom = mainContentTop + mainContentRect.height;
        const startY = Math.max(mainContentTop - window.innerHeight * .5, 0);
        const endY = mainContentBottom - window.innerHeight * .5;
        const diffY = endY - startY;
        const progress = Math.max((currentScrollY - startY) / diffY, 0);*/
        //progressBar.style.width = `${progress * 100}%`;

        var footer = document.querySelector('.main-footer');
        var percent = (mainContentRect.top) * -100 / (mainContent.offsetHeight - footer.offsetHeight);
        if(percent<0) percent = 0;
        if(percent>=100) percent = 100;
        progressBar.style.width = `${percent}%`;
    };

    const addListeners = () => {
        twitterShareBtn.addEventListener("click", onTwitterClick);
        facebookShareBtn.addEventListener("click", onFacebookClick);
        linkedInShareBtn.addEventListener("click", onLinkedInClick);

        copyLinkBtn.addEventListener("click", onCopyLinkClick);
        printBtn.addEventListener("click", onPrintClick);

        window.addEventListener("scroll", onScroll);
    };

    const init = () => {
        addListeners();
        onScroll();
    };

    init();
};